module.exports = __webpack_public_path__ + "static/media/servco pools_1715288152822.fe226c37.jpg";